import { usePointCloudContext } from 'features/pointClouds'
import { HSVFilterSlider } from 'pages/pointClouds/components/hud/controlPanel/HSVFilterSlider'
import React, { useMemo, useState } from 'react'
import { GeckoMeasurementRange, GeckoMeasurementUnit } from 'types'

export const HSVControls: React.FC = () => {
  const { setHueFilterRange } = usePointCloudContext()

  const fullValueRange = useMemo(() => {
    return GeckoMeasurementRange.CreateFromValues(
      0,
      360,
      GeckoMeasurementUnit.Millimeters
    )
  }, [])

  const [filteredValueRange, setFilteredValueRange] = useState<
    GeckoMeasurementRange | undefined
  >(
    GeckoMeasurementRange.CreateFromValues(
      0,
      360,
      GeckoMeasurementUnit.Millimeters
    )
  )

  const updateHueFilterRange = (e: GeckoMeasurementRange) => {
    setFilteredValueRange(e)
    setHueFilterRange([e.min.num, e.max.num])
  }
  return (
    <HSVFilterSlider
      measurementUnit={GeckoMeasurementUnit.Millimeters}
      step={1}
      fullValueRange={fullValueRange}
      filteredValueRange={filteredValueRange!}
      setFilteredValueRange={updateHueFilterRange}
    />
  )
}
